import type {ComponentProps, ElementType} from 'react'

export function assumeType<T>(_val: any): asserts _val is T {
    // no-op
}

export function assumeComponentProps<C extends ElementType>(_val: any): asserts _val is ComponentProps<C> {
    // no-op
}

// export function assumeHasProps<T extends object,U>(_val: U): asserts _val is T&U {
//     // no-op
// }


export function assumeDefinedProps<
    T extends object,
    K extends keyof T
>(
    obj: T,
    props: K[]
): asserts obj is T & { [P in K]-?: NonNullable<T[P]> } {
    // no-op
}
